import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    this.observer = new MutationObserver((mutations) => {
      const shouldScroll = mutations.some(mutation => {
        return mutation.type === 'childList' || mutation.type === 'characterData';
      });

      if (shouldScroll) {
        const form = document.querySelector(this.targetValue);
        if (form) {
          form.scrollIntoView({
            block: 'end'
          });
        }
      }
    });

    this.observer.observe(this.element, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
